import { Region } from '../shared/types';
import { usePreferences } from './usePreferences';

const useRegion = (): Region => {
  const { region } = usePreferences();
  return region;
};

export default useRegion;
